import {useTranslation} from "react-i18next";
import {css, Theme} from "@emotion/react";
import {elevation} from "@pg-design/elevation";
import {backgroundColor, borderRadius, flex, h100, onDesktop, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text";

import {SUBSCRIPTION_PERIODS} from "./BdSubscriptionBox";
import {Price} from "./Price";

interface IProps {
    paymentPeriod: SUBSCRIPTION_PERIODS;
}

const SUBSCRIPTION_PRICES = {
    monthly: "2000",
    annually: "1649"
};

export const AllCitiesPricingBox = ({paymentPeriod}: IProps) => {
    const {t} = useTranslation();
    const price = SUBSCRIPTION_PRICES[paymentPeriod];

    return (
        <div css={content}>
            <Text css={header} variant="headline_4" as="p">
                {t("pricing.bd_subscription.all_cities")}
            </Text>

            <Text css={descriptionWrapper} variant="body_copy_1">
                {t("pricing.bd_subscription.all_cities_description_1")}
                <b>{t("pricing.bd_subscription.all_cities_description_2")}</b>
                {t("pricing.bd_subscription.all_cities_description_3")}
            </Text>

            <Price price={price} primaryButton={{text: t("pricing.order"), href: "#contact"}} />
        </div>
    );
};

const divider = (theme: Theme) => css`
    border-bottom: 1px solid ${theme.colors.gray[300]};
`;

const descriptionWrapper = (theme: Theme) => css`
    ${p(3, 2, 3, 2)};
    ${divider(theme)};
`;

const header = (theme: Theme) => css`
    ${p(4, 2, 4, 2)};
    ${backgroundColor(theme.colors.gray["100"])};
    ${borderRadius(2, 2, 0, 0)};
    ${flex("center", "space-between")};
    min-height: 62px;
    ${onDesktop(css`
        min-height: 112px;
    `)}
`;

const content = css`
    ${borderRadius(2)};
    ${elevation(2)};
    background: #fff;
    ${h100};
`;
